// removed by extract-text-webpack-plugin
module.exports = {"new-payment-modal":"new-payment-modal","classtop-modal-content":"classtop-modal-content","processing-container":"processing-container","sleeve":"sleeve","new-payment-modal-content":"new-payment-modal-content","schemaLeft":"schemaLeft","schemaRight":"schemaRight","row":"row","price-on-modal":"price-on-modal","scan-msg":"scan-msg","scan-image-wrapper":"scan-image-wrapper","icon-ok":"icon-ok","circle-container":"circle-container","circle1":"circle1","blink-animation":"blink-animation","circle2":"circle2","circle3":"circle3","circle4":"circle4","circle5":"circle5"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/NewPayment/Modal.scss
// module id = UmdA
// module chunks = 0